/**
 * Media for the medications hub how-it-works card.
 *
 * BUNDLED, not streamed. The clip ships inside the app binary so it plays
 * instantly with no network — which is the actual field condition, since a
 * nurse standing in a patient's kitchen often has no usable signal, and a
 * coaching video that spins on a buffer is a coaching video nobody watches.
 *  480x858, 7s, 1.4 MB — small enough that bundling costs nothing
 * meaningful (the retired `assets/medication-intro.mp4` was 2.7 MB).
 *
 * The trade-off: changing the clip needs an app release. Accepted — this is
 * evergreen instructional content, not something that churns.
 */

// eslint-disable-next-line @typescript-eslint/no-require-imports
export const MEDICATION_INTRO_VIDEO = require("@/assets/medication-wizard/medication-intro.mp4");

/**
 * Runtime shown on the HOW IT WORKS chip.
 *
 * DIVERGENCE from the design package, deliberate: it hardcodes "0:42", but the
 * clip is 7.0s. Printing 0:42 over a 7-second video is a promise the card
 * cannot keep, and the nurse notices the moment it ends early.
 */
export const MEDICATION_INTRO_DURATION_LABEL = "0:07";
